import ResourcePage from "@/components/ResourcePage";
import PageHeader from "@/components/PageHeader";
import { VENDOR_CATEGORIES } from "@/lib/constants";

const fields = [
  { name: "name", label: "Nama Vendor", required: true },
  { name: "category", label: "Kategori", type: "select", options: VENDOR_CATEGORIES, required: true, default: "Venue" },
  { name: "contact_person", label: "Contact Person" },
  { name: "phone", label: "No. WhatsApp" },
  { name: "email", label: "Email", type: "email" },
  { name: "address", label: "Alamat", full: true },
  { name: "price", label: "Harga", type: "number" },
  { name: "rating", label: "Rating (0-5)", type: "number" },
  { name: "status", label: "Status", type: "select", options: ["Active", "Inactive"], default: "Active" },
  { name: "portfolio", label: "Link Portfolio (opsional)" },
  { name: "portfolio_file", label: "Upload Foto Portfolio", type: "file", full: true },
  { name: "notes", label: "Catatan", type: "textarea", full: true },
];

const columns = [
  { key: "name", label: "Vendor", render: (r) => <span className="font-semibold text-[#1A1A1A]">{r.name}</span> },
  { key: "category", label: "Kategori" },
  { key: "contact_person", label: "Contact" },
  { key: "phone", label: "WhatsApp" },
  { key: "price", label: "Harga", money: true },
  { key: "rating", label: "Rating", render: (r) => <span className="text-gold-dark font-semibold">★ {r.rating || "-"}</span> },
  { key: "status", label: "Status", badge: true },
];

export default function Vendors() {
  return (
    <ResourcePage
      resource="vendors" title="Vendor" writeLevel={3}
      columns={columns} fields={fields}
      PageHeaderComp={<PageHeader overline="Database Vendor" title="Vendors" subtitle="Kelola daftar vendor dan mitra untuk setiap event." />}
    />
  );
}
